import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  confirmCompanyRequest as confirmCompanyRequestApi,
  loadCompanyRequests as loadCompanyRequestsApi,
  mergeCompanyRequest as mergeCompanyRequestApi,
  rejectCompanyRequest as rejectCompanyRequestApi,
} from '../api'

export const loadCompanyRequests = createAsyncThunk(
  'companyRequests/loadCompanyRequests',
  async (params, { rejectWithValue }) => {
    try {
      const response = await loadCompanyRequestsApi(params)
      return response.data
    } catch (error) {
      rejectWithValue(error.response.data)
    }
  }
)

export const confirmCompanyRequest = createAsyncThunk(
  'company/confirmCompanyRequest',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await confirmCompanyRequestApi(id)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const rejectCompanyRequest = createAsyncThunk(
  'company/rejectCompanyRequest',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await rejectCompanyRequestApi(id)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const mergeCompanyRequest = createAsyncThunk(
  'company/mergeCompanyRequest',
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const response = await mergeCompanyRequestApi(data, id)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

const companyRequestSlice = createSlice({
  name: 'companyRequests',
  initialState: {
    requests: [],
    pendingCompanies: [],
    error: null,
    currentRequest: null,
    errorsFromServer: { confirm: null, reject: null, merge: null },
    confirmCompanyRequestModalVisibility: false,
    confirmedSuccessModalVisibility: false,
    mergeCompanyRequestModalVisibility: false,
    mergedSuccessModalVisibility: false,
    rejectCompanyRequestModalVisibility: false,
    rejectedSuccessModalVisibility: false,
  },
  reducers: {
    setCurrentRequest: (state, action) => {
      state.currentRequest = action.payload
    },
    clearErrorsFromServer: (state, action) => {
      state.errorsFromServer[action.payload] = null
    },
    setConfirmCompanyRequestModalVisibility: (state, action) => {
      state.confirmCompanyRequestModalVisibility = !!action.payload
    },
    setConfirmedSuccessModalVisibility: (state, action) => {
      state.confirmedSuccessModalVisibility = !!action.payload
    },
    setMergeCompanyRequestModalVisibility: (state, action) => {
      state.mergeCompanyRequestModalVisibility = !!action.payload
    },
    setMergedSuccessModalVisibility: (state, action) => {
      state.mergedSuccessModalVisibility = !!action.payload
    },
    setRejectCompanyRequestModalVisibility: (state, action) => {
      state.rejectCompanyRequestModalVisibility = !!action.payload
    },
    setRejectedSuccessModalVisibility: (state, action) => {
      state.rejectedSuccessModalVisibility = !!action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadCompanyRequests.fulfilled, (state, action) => {
        state.requests = action.payload.company_requests
        state.pendingCompanies = action.payload.company_requests.map((request) => request.company_alias.company)
      })
      .addCase(loadCompanyRequests.rejected, (state, action) => {
        state.error = action.error.message
      })
      .addCase(confirmCompanyRequest.fulfilled, (state, { payload }) => {
        state.confirmCompanyRequestModalVisibility = false
        state.confirmedSuccessModalVisibility = true
      })
      .addCase(confirmCompanyRequest.rejected, (state, { payload }) => {
        state.errorsFromServer.confirm = payload.error
      })
      .addCase(rejectCompanyRequest.fulfilled, (state, { payload }) => {
        state.rejectCompanyRequestModalVisibility = false
        state.rejectedSuccessModalVisibility = true
      })
      .addCase(mergeCompanyRequest.fulfilled, (state, { payload }) => {
        state.mergeCompanyRequestModalVisibility = false
        state.mergedSuccessModalVisibility = true
      })
      .addCase(mergeCompanyRequest.rejected, (state, { payload }) => {
        state.errorsFromServer.merge = payload.error
      })
  },
})

export const {
  setCurrentRequest,
  clearErrorsFromServer,
  setConfirmCompanyRequestModalVisibility,
  setConfirmedSuccessModalVisibility,
  setMergeCompanyRequestModalVisibility,
  setMergedSuccessModalVisibility,
  setRejectCompanyRequestModalVisibility,
  setRejectedSuccessModalVisibility,
} = companyRequestSlice.actions

export const companyRequestReduce = companyRequestSlice.reducer
